/**
 * This object matches src/app/subscription/constants/subscription-use-case.enum.ts
 * in onlive-ms-communications.
 */
export const SubscriptionUseCaseEnum = {
    LegalDocAgreement: 'LegalDocAgreement',
    InvitationConfirmation: 'InvitationConfirmation',
    SessionRequestReceived: 'SessionRequestReceived',
    RemarketingToLeads: 'RemarketingToLeads',
    GameWinners: 'GameWinners',
    LicenseRequestAccepted: 'LicenseRequestAccepted',
    SignUpRequestReceived: 'SignUpRequestReceived',
    NewOrganizationRoiRequest: 'NewOrganizationRoiRequest',
    PasswordReset: 'PasswordReset',
    TriageCreated: 'TriageCreated',
    TriageOtp: 'TriageOtp',
    SummaryDashboardMetrics: 'SummaryDashboardMetrics',
    SummaryActivityAccount: 'SummaryActivityAccount',
    EventAccessCode: 'EventAccessCode',
    AccessCode: 'AccessCode',
    WebhookFailing: 'WebhookFailing'
}